import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import Grid from 'components/Grid';

export const StyledSectionPage = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
`;

export const StyledSectionTitle = styled.div`
  text-align: left;
  width: ${scaleSize(282)}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledGrid = styled(Grid)`
  margin: 0;
  position: relative;
  top: ${scaleSize(165)}px;
  left: ${scaleSize(245)}px;
  width: ${scaleSize(1725)}px;
  white-space: normal;
`;

export const StyledTabGrid = styled(Grid)`
  margin: 0;
  position: relative;
  top: ${scaleSize(80)}px;
  left: ${scaleSize(133)}px;
  width: ${scaleSize(1445)}px;
  white-space: normal;
`;
